import { TripFolder } from '../../lib/types/models/trip-folder/trip-folder'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTripFolder(data: UpdateInput<TripFolder>) {
  const { id, ...rest } = data
  return restApiClient.url(constructApiUrl(API.tripFolder.update.url, { id })).patch(rest)
}
